import React from "react";
import { useParams } from "react-router-dom";
import { useWhiteLabel } from "@lib/context";
import { AppContext } from "@lib/types/Context";
import { SharedManagerDetail } from "@app/shared";
import { NoPermission } from "@lib/components/AppComponents";

const CustomerManagerDetail: React.FC = () => {
  const { customerId } = useParams();
  const { permissions } = useWhiteLabel();

  // Check if user has permission to view wallet pool
  if (!permissions.canViewWalletPool) {
    return <NoPermission />;
  }

  return (
    <SharedManagerDetail
      context={AppContext.CUSTOMER}
      customerId={customerId}
    />
  );
};

export default CustomerManagerDetail;
